import React from 'react';

type StatusType =
  | 'Pending_Review' |'Loading' |'Delivered_Synced' |'Active' |'Pending' |'Suspended' |'Supplier_Only' |'Retailer_Only' |'Hybrid_Supplier_Retailer' |'Dry' |'Chilled' |'Frozen' |'Cash' |'Deferred_Credit' |'Bank_Card' |'Cheque' |'Mobile_Wallet';

const statusConfig: Record<StatusType, { label: string; className: string }> = {
  Pending_Review: { label: 'En Attente', className: 'status-badge-pending' },
  Loading: { label: 'En Chargement', className: 'status-badge-loading' },
  Delivered_Synced: { label: 'Livré ✓', className: 'status-badge-delivered' },
  Active: { label: 'Actif', className: 'status-badge-active' },
  Pending: { label: 'En Attente', className: 'status-badge-pending' },
  Suspended: { label: 'Suspendu', className: 'status-badge-suspended' },
  Supplier_Only: { label: 'Fournisseur', className: 'status-badge-loading' },
  Retailer_Only: { label: 'Détaillant', className: 'status-badge-active' },
  Hybrid_Supplier_Retailer: { label: 'Hybride', className: 'status-badge-hybrid' },
  Dry: { label: 'Sec', className: 'bg-amber-50 text-amber-700' },
  Chilled: { label: 'Réfrigéré', className: 'bg-blue-50 text-blue-700' },
  Frozen: { label: 'Congelé', className: 'bg-indigo-50 text-indigo-700' },
  Cash: { label: 'Espèces', className: 'bg-green-50 text-green-700' },
  Deferred_Credit: { label: 'Crédit Différé', className: 'status-badge-pending' },
  Bank_Card: { label: 'Carte Bancaire', className: 'status-badge-loading' },
  Cheque: { label: 'Chèque', className: 'bg-purple-50 text-purple-700' },
  Mobile_Wallet: { label: 'Mobile Wallet', className: 'bg-teal-50 text-teal-700' },
};

interface StatusBadgeProps {
  status: StatusType;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config = statusConfig[status] ?? { label: status, className: 'bg-muted text-muted-foreground' };
  return (
    <span className={`inline-flex items-center font-600 rounded-full ${
      size === 'sm' ? 'text-2xs px-1.5 py-0.5' : 'text-xs px-2 py-1'
    } ${config.className}`}>
      {config.label}
    </span>
  );
}